// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IMonthlyClaimSpendDto
 */
export interface IMonthlyClaimSpendDto {
    /**
     * 
     * @type {Date}
     * @memberof IMonthlyClaimSpendDto
     */
    month?: Date;
    /**
     * 
     * @type {number}
     * @memberof IMonthlyClaimSpendDto
     */
    claim_spend?: number;
}

/**
 * Check if a given object implements the IMonthlyClaimSpendDto interface.
 */
export function instanceOfIMonthlyClaimSpendDto(value: object): value is IMonthlyClaimSpendDto {
    return true;
}

export function IMonthlyClaimSpendDtoFromJSON(json: any): IMonthlyClaimSpendDto {
    return IMonthlyClaimSpendDtoFromJSONTyped(json, false);
}

export function IMonthlyClaimSpendDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IMonthlyClaimSpendDto {
    if (json == null) {
        return json;
    }
    return {
        
        'month': json['month'] == null ? undefined : (new Date(json['month'])),
        'claim_spend': json['claim_spend'] == null ? undefined : json['claim_spend'],
    };
}

export function IMonthlyClaimSpendDtoToJSON(json: any): IMonthlyClaimSpendDto {
    return IMonthlyClaimSpendDtoToJSONTyped(json, false);
}

export function IMonthlyClaimSpendDtoToJSONTyped(value?: IMonthlyClaimSpendDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'month': value['month'] == null ? undefined : ((value['month']).toISOString().substring(0,10)),
        'claim_spend': value['claim_spend'],
    };
}

